import { POST_CLASS_NAME } from '../../../post/model/constants'

import getClassNameReduxUtil from '../../utils/get-class-name'
import { afterSaveAssociationPostHook } from '../../../post'

const CLASS_NAME_TO_FUNCTION = {
  [POST_CLASS_NAME]: afterSaveAssociationPostHook
}

function afterSaveAssociationReduxHook (instance, state, options) {
  const className = getClassNameReduxUtil(instance)
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return state
  }
  return fn(instance, state, options)
}

export default afterSaveAssociationReduxHook
